import React from "react";

import "../Auth/auth.css";

class ResetPassword extends React.Component {
  render() {
    return <div className="auth-container">
      <div className="reset-password">
      <p className="large-title">Need to reset your password?</p>
      <div className="error-box" id="error-text"></div>
      <form action="https://ops-resetpassword.builtwithdark.com/reset" method="POST">
        <input type="text" placeholder="Email Address" id="email" name="email" />
        <button type="submit">Reset Password</button>
      </form>
    </div>
    <p className="auth-links">Don't have account? <a href="/beta">Sign Up</a></p>
    </div>;
  }
}

export default ResetPassword;
